import { useEffect } from "react";
// import { getOpportunitiesApi } from "../../common/apis/opportunities.api";
import { IOpportunity } from "../../common/constants/app.dto";
import { CardOpportunity } from "../../common/components/card/opportunity";
import { textChooser } from "../../common/util/textChooser";
import { useUser } from "../../common/hooks/User";
import "./favorites.style.scss";

export const Favorites = () => {

    const favorites = useUser().getDataByAttributeName("favorites");

    useEffect(() => {
        
    // eslint-disable-next-line
    }, []);

    const renderNoFavorites = () => {
        return (
            <div className="no-favorites">
                <h2>No favorites</h2>
                <p>No tienes ningun puesto o postulacion aun.</p>
            </div>
        )
    }

    return(
        <div className="page -favorites">
            <h1 className="page-title">{textChooser("txt55")}</h1>

            <section className="favorites-section">
                {!favorites.length && renderNoFavorites()}

                {!!favorites.length && favorites.map((ops: IOpportunity) => (
                    <CardOpportunity {...ops} key={ops.id} />
                ))}
            </section>
        </div>
    )
}